export const ROLES = {
  TELEMATICLAB_ADMIN: 'APP208:telematic_lab_user',
};
